var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00106 6.9512C6.02766 6.41226 6.50183 5.97839 7.04013 6.0009C7.58047 6.02341 8.0178 6.49344 7.99938 7.0317C7.98027 7.58496 7.49315 8.03111 6.94325 7.99837C6.40359 7.9663 5.97513 7.48945 6.00106 6.9512Z",
    fill: "#3A3A39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00323 18C6.90418 17.8688 6.82699 17.787 6.77303 17.6922C5.88365 16.1249 4.60901 14.8867 3.36238 13.6217C2.41153 12.657 1.52967 11.6394 0.882101 10.4335C-1.55446 5.89175 1.40671 1.08817 5.49361 0.16332C9.26902 -0.691444 13.1817 1.9024 13.8819 5.75983C14.2876 7.99637 13.621 9.94982 12.2964 11.6971C11.6448 12.5574 10.8866 13.34 10.1372 14.1199C9.0921 15.2083 8.0381 16.2843 7.28261 17.6104C7.21088 17.7341 7.11593 17.8433 7.00323 18ZM10.0033 7.12443C10.0033 5.46781 8.65971 4.10939 7.01484 4.10183C5.35289 4.09427 3.99287 5.45475 3.99287 7.12443C3.99287 8.78036 5.33718 10.1402 6.98137 10.147C8.64263 10.1546 10.0033 8.79342 10.0033 7.12443Z",
    fill: "#3A3A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.937f21694abef778115aa17a5fb69666.svg";
export { ForwardRef as ReactComponent };